import { render, staticRenderFns } from "./phone-block-modal.vue?vue&type=template&id=ca23fda0&scoped=true"
import script from "./phone-block-modal.vue?vue&type=script&lang=js"
export * from "./phone-block-modal.vue?vue&type=script&lang=js"
import style0 from "./phone-block-modal.vue?vue&type=style&index=0&id=ca23fda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca23fda0",
  null
  
)

export default component.exports